import { getHublet } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { isNewLoggedInAccount } from './endpointStateChecks';
import { EndpointKey } from './EndpointKey';
import { getIsActiveAndAssignedToVariant, getParameter } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import Logger from '../lib/Logger';
import { getSentryExtra } from '../error/getSentryExtra';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { writeHubUserAttribute } from '../utils/hubUserAttribute';
import { Tracker } from '../store/tracking/action-creators';
const COAC0001_TREATMENT_HUB_USER_ATTRIBUTE_KEY = 'GrowthCoaching:COAC0001Treatment';
const storeCoac0001Treatment = state => {
  const hublet = getHublet(state);
  const coac0001Treatment = getParameter(state, ExperimentKeys.COAC0001);
  return writeHubUserAttribute(COAC0001_TREATMENT_HUB_USER_ATTRIBUTE_KEY, coac0001Treatment, hublet);
};
export const LOG = Logger.getLogger('storeCoac0001TreatmentError');
export const EndpointsStoreCoac0001Treatment = {
  [EndpointKey.StoreCoac0001Treatment]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state =>
    // Is the Portal created so we can use the Hub User Attributes API?
    isPortalIdDefined(state) &&
    // Is the user in the COAC0001 experiment?
    getIsActiveAndAssignedToVariant(state, ExperimentKeys.COAC0001, [ExperimentParameterGroup.Control, ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]) &&
    // Is the user authed for API usage?
    isNewLoggedInAccount(state),
    method: storeCoac0001Treatment,
    handleSuccess: (response, dispatch) => {
      dispatch(Tracker.signupInteraction('success-store-coac0001-treatment'));
    },
    handleError: (error, dispatch, getState) => {
      dispatch(Tracker.signupInteraction('error-store-coac0001-treatment'));
      const numberOfStoreTreatmentRetries = getEndpointRetries(getState(), EndpointKey.StoreCoac0001Treatment);
      LOG.error('Storing COAC0001 treatment error', {
        extra: Object.assign({}, getSentryExtra(error), {
          totalNumberOfCalls: numberOfStoreTreatmentRetries
        })
      });
      // Retry every second, up to 5 times
      if (numberOfStoreTreatmentRetries < 5) {
        dispatch(Tracker.signupInteraction('retry-store-coac0001-treatment', {
          totalNumberOfCalls: numberOfStoreTreatmentRetries
        }));
        dispatch(retryEndpoint(EndpointKey.StoreCoac0001Treatment, 1000));
      }
    }
  }
};